import React from "react";
import { CreditCardOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Typography } from "antd";
import type { FormInstance } from "antd";
import GradientButton from "../../../../common/UI/GradientButton";
import MY_DEVICES from "../constants";
import type { ActivationState } from "../types";

const { Text, Title } = Typography;

interface ActivationModalProps {
  activationState: ActivationState | null;
  activationForm: FormInstance<{ macAddress: string }>;
  submitting: boolean;
  onClose: () => void;
  onFinish: (values: { macAddress: string }) => Promise<void>;
}

const ActivationModal: React.FC<ActivationModalProps> = ({
  activationState,
  activationForm,
  submitting,
  onClose,
  onFinish,
}) => (
  <Modal
    centered
    open={Boolean(activationState?.open)}
    onCancel={onClose}
    footer={null}
    className="my-devices-activation-modal"
    destroyOnHidden
  >
    <div className="my-devices-activation-panel">
      <div className="my-devices-activation-icon">
        <CreditCardOutlined />
      </div>

      <Title level={4}>{MY_DEVICES.LABELS.ACTIVATE_DEVICE}</Title>

      <Text>
        Enter the MAC address for{" "}
        {activationState?.order.productName || "this device"}.
      </Text>

      <Form
        form={activationForm}
        layout="vertical"
        className="my-devices-activation-form"
        onFinish={onFinish}
      >
        <Form.Item
          name="macAddress"
          rules={[
            { required: true, message: MY_DEVICES.LABELS.MAC_REQUIRED },
            {
              pattern: MY_DEVICES.MAC_ADDRESS.PATTERN,
              message: `Use format ${MY_DEVICES.MAC_ADDRESS.PLACEHOLDER}`,
            },
          ]}
        >
          <Input placeholder={MY_DEVICES.MAC_ADDRESS.PLACEHOLDER} />
        </Form.Item>

        <GradientButton block size="large" htmlType="submit" loading={submitting}>
          {MY_DEVICES.LABELS.ACTIVATE_HOME_PHONE}
        </GradientButton>
      </Form>
    </div>
  </Modal>
);

export default ActivationModal;
